  <template>
  <div class="main_profile_wrapper" :key="$route.params.id">
    <div class="main_table">
      <!-- v-if="hasPermission('create group_cards_users')" -->
       
      <TableHeaderSection
        :title="`${localization(groupName)} ${localization('Group Members')}`"
        :text="`${localization('Manage group members.')}`"
        :buttonText="canAssignInstructors ? `${localization('Add New Member')}` : ''"
        :total="groupMembers.length"
        @toggleModal="showAddMemberModal"
      ></TableHeaderSection>

      <div class="p-3 bg-light border-bottom d-flex justify-content-end align-items-center" v-if="selectedMembers.length > 0">
        <span class="mr-3 text-muted small">
          {{ selectedMembers.length }} {{ localization('members selected') }}
        </span>
        <el-button type="primary" size="medium" @click="printAllSelected">
          <i class="fa fa-print mr-1"></i> {{ localization('Print Selected Launch Cards') }}
        </el-button>
      </div>

      <div class="header_container just_custom_table_tasks">
        <CustomTable
          :count="totalGroupMembers"
          :DataItems="groupMembers"
          @Refresh="fetchMembers"
          @selection="handleSelectionChange"
          :filter="filter"
          :title="'group_members'"
          hidden_export_import
          @reset-filters="filter = {}"
          viewName="GroupMembers"
        >
          <template #columns>
            <el-table-column type="selection" width="55"></el-table-column>
            <el-table-column prop="first_name" :label="`${localization('Name')}`">
              <template #default="{ row }">
                 <div class="pl-2">
                  <router-link :to="`/user-details/${row.id}`">
                    {{ row.first_name }} {{ row.last_name }}
                  </router-link>
                  <span class="d-block text-muted small">{{ row.email }}</span>
                </div>
              </template>
            </el-table-column>

            <el-table-column prop="topic_name" :label="`${localization('Topic Name')}`">
              <template #default="{ row }">
                <div class="pl-2">
                  {{ subTopicsCards.length > 0 ? subTopicsCards[0].topic_card_name : '' }}
                </div>
              </template>
            </el-table-column>

            <el-table-column prop="subtopics" :label="`${localization('Subtopic')}`">
              <template #default="{ row }">
                <div class="pl-2">
                  <div v-for="subtopic in subTopicsCards" :key="subtopic.id" class="mb-1">
                    <el-tag size="mini" type="info">{{ subtopic.name }}</el-tag>
                  </div>
                </div>
              </template>
            </el-table-column>

            <el-table-column prop="status" :label="`${localization('Subtopic Status')}`">
              <template #default="{ row }">
                <el-tag
                  :type="row.status === 'completed' ? 'success' : row.status === 'answered' ? 'primary' : 'warning'"
                  size="small"
                >
                  {{ localization(row.status || 'new') }}
                </el-tag>
              </template>
            </el-table-column>

            <el-table-column prop="" :label="`${localization('Actions')}`" width="180">
               <template slot-scope="scope">
                <div class="td-actions d-flex align-items-center">
                  <a
                    v-tooltip.top-center="`${localization('View Answers')}`"
                    @click="viewMemberAnswers(scope.row)"
                    class="mr-3"
                  >
                    <i class="fa fa-eye text-dark" style="font-size: 1.2rem; cursor: pointer;"></i
                    >
                  </a>
                  <a
                    v-tooltip.top-center="`${localization('Print Launch Card')}`"
                    @click="printMemberAnswers(scope.row)"
                    class="mr-3"
                  >
                    <i class="fa fa-print text-primary" style="font-size: 1.5rem; cursor: pointer;"></i>
                  </a>
                  <a
                    v-if="!isStudent"
                    v-tooltip.top-center="scope.row.status === 'completed' ? `${localization('Mark as Answered')}` : `${localization('Mark as Completed')}`"
                    @click="toggleCompleted(scope.row)"
                    class="mr-3"
                  >
                    <i
                      class="fa fa-check-circle"
                      :style="scope.row.status === 'completed'
                        ? 'font-size: 1.5rem; cursor: pointer; color: #28a745;'
                        : 'font-size: 1.5rem; cursor: pointer; color: #adb5bd; opacity: 0.5;'"
                    ></i>
                  </a>
                  <span>
                    <a
                      v-tooltip.top-center="`${localization('Delete Member')}`"
                      @click="removeMember(scope.row.id)"
                    >
                      <img
                        role="button"
                        src="@/assets/new-theme/delete-button-table.png"
                        alt="delete"
                      />
                    </a>
                  </span>
                </div>
               </template>
            </el-table-column>
          </template>
        </CustomTable>
      </div>
    </div>

    <!-- Subtopics Table -->
    <div class="main_table mt-4">
      <div class="p-4 border-bottom d-flex align-items-center justify-content-between">
        <div>
          <h4 class="m-0 font-weight-bold text-dark">{{ localization('Subtopics') }}</h4>
          <p class="text-muted small m-0">{{ localization('List of subtopics assigned to this group.') }}</p>
        </div>
        <el-tag type="info" size="medium">{{ subTopicsCards.length }} {{ localization('Subtopics') }}</el-tag>
      </div>

      <div class="header_container just_custom_table_tasks">
        <CustomTable
          :count="totalSubTopicsCards"
          :DataItems="subTopicsCards"
          @Refresh="fetchSubTopicsCards"
          :filter="subtopicFilter"
          :title="'sub_topics'"
          hidden_export_import
          @reset-filters="subtopicFilter = {}"
          viewName="SubTopics"
        >
          <template #columns>
            <el-table-column prop="name" :label="`${localization('Subtopic Name')}`">
              <template #default="{ row }">
                <div class="pl-2 font-weight-bold text-dark">
                  {{ row.name }}
                </div>
              </template>
            </el-table-column>

            <el-table-column prop="topic_card_name" :label="`${localization('Topic Name')}`">
              <template #default="{ row }">
                <div class="pl-2">
                  <el-tag size="small" type="success">{{ row.topic_card_name }}</el-tag>
                </div>
              </template>
            </el-table-column>
          </template>
        </CustomTable>
      </div>
    </div>

    <!-- Add Member Modal -->
    <el-dialog
      :title="localization('Add Additional Members')"
      :visible.sync="showModal"
      width="600px"
      top="5vh"
      custom-class="task-modal global_modal"
      :close-on-click-modal="true"
    >
      <div class="custom_modal_header">
        <div class="images">
           <img src="@/assets/new-theme/icons/users-plus.png" alt="file" />
          <img
            @click="closeModal"
            class="close_img"
            src="@/assets/new-theme/x-close-modal.png"
            alt="file"
          />
        </div>
        <h3 class="title font-weight-bold mt-3">
          {{ localization("Add Additional Members") }}
        </h3>
        <p class="description">
          {{ localization("Add new members to the group.") }}
        </p>
      </div>
      <el-form :model="form" ref="addMemberForm">


        <el-form-item
          v-if="isPlatformAdmin && !currentGroupOrganizationId"
          :label="localization('Institution')"
        >
            <el-select
              v-model="form.organization_id"
              filterable
              :placeholder="localization('Select institution')"
              class="w-100"
              @change="handleOrganizationChange"
            >
              <el-option
                v-for="org in organizations"
                :key="org.id"
                :label="org.name"
                :value="org.id"
              ></el-option>
            </el-select>
        </el-form-item>

        <el-form-item :label="localization('Assign instructors')">
            <el-select
              v-model="form.institution_users"
              multiple
              filterable
              :disabled="isInstructorPickerDisabled"
              :placeholder="instructorPickerPlaceholder"
              class="w-100"
            >
              <el-option
                v-for="user in institutionInstructors"
                :key="user.id"
                :label="instructorLabel(user)"
                :value="user.id"
              ></el-option>
            </el-select>
            <p v-if="assignError" class="text-danger small mt-1 mb-0">{{ assignError }}</p>
        </el-form-item>


      </el-form>
      <div class="lci_modal_buttons mt-5">
        <button @click="closeModal" class="lci_btn_modal_cancel ">
          {{ localization("Cancel") }}
        </button>
        <button @click="submitAddMembers" class="lci_btn save lci_btn_modal_cancel">
          {{ localization("Save") }}
        </button>
      </div>
    </el-dialog>

    <!-- Start Design For Print -->
    <div v-if="printingMembers && printingMembers.length > 0" class="the_main_container_for_print_all_pdf bg-white">
      <div
        v-for="(pm, pmIndex) in printingMembers"
        :key="pm.user.id"
        class="print-member-block"
      >
        <div class="main_container">
          <!-- User Header info -->
          <div class="main_auth_user_info text-center border-bottom pb-2 mb-2">
            <h2 class="n_name font-weight-bold mb-1">
              {{ pm.user.first_name }} {{ pm.user.last_name }}
            </h2>
            <p class="n_email text-muted mb-2">{{ pm.user.email }}</p>
            <span class="badge badge-primary px-3 py-2 text-white" style="font-size: 1rem; background-color: #7f56d9;">
              {{ localization('Topic') }}: {{ subTopicsCards.length > 0 ? subTopicsCards[0].topic_card_name : '' }}
            </span>
            <div class="patterns_wrapper mt-4 text-left">
              <div class="wrapper_for_pattern">
                <!-- Sequence -->
                <div class="main_pattern_card">
                  <div class="part_one round_card" style="background-color: #39c;">
                    <span class="pattern_name">{{ localization('Sequence (S)') }}</span>
                    <div class="numbers_wrapper">
                      <span class="number">{{ pm.user.sequence != null ? pm.user.sequence : 0 }}</span>
                      <span class="number_key">{{ getScoreLabel(pm.user.sequence) }}</span>
                    </div>
                  </div>
                </div>
                <!-- Precision -->
                <div class="main_pattern_card">
                  <div class="part_one round_card" style="background-color: #3c3;">
                    <span class="pattern_name">{{ localization('Precision (P)') }}</span>
                    <div class="numbers_wrapper">
                      <span class="number">{{ pm.user.precision != null ? pm.user.precision : 0 }}</span>
                      <span class="number_key">{{ getScoreLabel(pm.user.precision) }}</span>
                    </div>
                  </div>
                </div>
                <!-- Technical Reasoning -->
                <div class="main_pattern_card">
                  <div class="part_one round_card" style="background-color: #f93;">
                    <span class="pattern_name">{{ localization('Technical Reasoning (T)') }}</span>
                    <div class="numbers_wrapper">
                      <span class="number">{{ pm.user.technical_reasoning != null ? pm.user.technical_reasoning : 0 }}</span>
                      <span class="number_key">{{ getScoreLabel(pm.user.technical_reasoning) }}</span>
                    </div>
                  </div>
                </div>
                <!-- Confluence -->
                <div class="main_pattern_card">
                  <div class="part_one round_card" style="background-color: #c36;">
                    <span class="pattern_name">{{ localization('Confluence (C)') }}</span>
                    <div class="numbers_wrapper">
                      <span class="number">{{ pm.user.confluence != null ? pm.user.confluence : 0 }}</span>
                      <span class="number_key">{{ getScoreLabel(pm.user.confluence) }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Subtopics and Answers -->
          <div
            v-for="(subtopic, subIndex) in pm.subtopics"
            :key="subtopic.id"
            class="print-page-break mb-2"
          >
            <div class="subtopic-print-header mb-2">
              <h3 class="font-weight-bold text-dark mb-1" style="font-size: 1.5rem; border-left: 4px solid #7f56d9; padding-left: 10px;">
                {{ subtopic.name }}
              </h3>
              <p class="text-muted">{{ subtopic.description }}</p>
            </div>

            <!-- Components -->
            <div v-if="subtopic.components && subtopic.components.length > 0">
              <div
                v-for="(component, compIndex) in subtopic.components"
                :key="component.id"
                class="component-print-block mb-2 p-2 border rounded"
              >
                <h4 class="font-weight-bold text-secondary mb-2" style="font-size: 1.15rem;">
                  {{ component.title }}
                </h4>
                <div class="component-body mb-3 text-muted" v-if="component.body" v-html="component.body"></div>

                <!-- Question Cards -->
                <div v-if="component.question_cards && component.question_cards.length > 0" class="mt-3">
                  <div v-for="(qCard, qIndex) in component.question_cards" :key="qCard.id" class="mb-4 page-break-inside-avoid">
                    <!-- MCQ Choices -->
                    <div v-if="qCard.type === 'mcq' && qCard.choices && qCard.choices.length > 0">
                      <div class="d-flex align-items-start mb-2 pl-3 border-left" style="border-width: 3px !important; border-color: #7f56d9 !important;">
                        <span class="badge badge-secondary mr-2 mt-1 text-white" style="background-color: #7f56d9;">
                          {{ qIndex + 1 }}
                        </span>
                        <span class="font-weight-bold text-dark" style="font-size: 0.95rem;">
                          {{ qCard.question }}
                        </span>
                      </div>
                      <div class="pl-5 mt-2">
                        <div
                          v-for="choice in qCard.choices"
                          :key="choice.id"
                          class="choice-row d-flex align-items-center mb-1 p-2 rounded border"
                          :style="qCard.student_answer === choice.id ? 'background-color: #f9f5ff; border-color: #7f56d9; border-left: 4px solid #7f56d9;' : 'background-color: #ffffff; border-color: #eaecf0;'"
                        >
                          <i v-if="qCard.student_answer === choice.id" class="fa fa-dot-circle-o text-primary mr-2" style="color: #7f56d9;"></i>
                          <i v-else class="fa fa-circle-o text-muted mr-2"></i>
                          <span :class="{'text-primary font-weight-bold': qCard.student_answer === choice.id, 'text-secondary': qCard.student_answer !== choice.id}">
                            {{ choice.text }}
                          </span>
                        </div>
                      </div>
                    </div>

                    <!-- Text Answer (Essay styled card) -->
                    <div v-else class="essay-question-container text-left">
                      <div class="essay-question-header">
                        <div class="essay-step-label">
                          Step {{ parseQuestionCard(qCard, qIndex).stepNumber }}: <strong>{{ parseQuestionCard(qCard, qIndex).stepName }}</strong>
                        </div>
                        <div class="essay-main-question">
                          {{ parseQuestionCard(qCard, qIndex).mainQuestion }}
                        </div>
                        <div class="essay-help-text" v-if="parseQuestionCard(qCard, qIndex).helpText" v-html="formatHelpText(parseQuestionCard(qCard, qIndex).helpText)">
                        </div>
                      </div>
                      <div class="essay-question-body">
                        <div class="essay-answer-preview">
                          {{ qCard.student_answer || qCard.answer || localization('No answer submitted yet.') }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// Use CustomTable as seen in index.vue, assuming it's globally registered or I need to find where it is imported.
// In index.vue it is used. I'll assume global or I check main.js.
// Wait, index.vue didn't import CustomTable explicitly in the script shown in `view_file` (lines 1-280 of index.vue).
// Let me check index.vue imports again. Ah, likely globally registered or imported in a truncated part?
// Reading index.vue lines 135-241 shows imports: mapGetters, Swal.
// If CustomTable is not imported in index.vue, it must be global.
// I will proceed assuming it is global or handled by matching index.vue.
// UPDATE: I will import mapGetters.

import { mapGetters } from "vuex";
import Swal from "sweetalert2";
import request, { extractApiError } from "@/utils/request";

export default {
  name: "DataCardsShow",
  data() {
    return {
      filter: {},
      subtopicFilter: {},
      showModal: false,
      localLoading: false,
      printingMembers: [],
      selectedMembers: [],
      form: {
        institution_users: [],
        organization_id: null
      },
      assignError: ""
    };
  },
  computed: {
    ...mapGetters("data_cards", [
      "groupMembers",
      "subTopicsCards",
      "loading",
      "totalGroupMembers",
      "totalSubTopicsCards",
      "groupName",
      "currentGroupCard",
      "institutionInstructors"
    ]),
    organizations() {
      return this.$store.getters["organization/orgs"] || [];
    },
    authRoleNames() {
      const roles = this.$store.getters["roles/authUserRoles"] || [];
      return roles.map(r => String(r).toLowerCase());
    },
    isPlatformAdmin() {
      return this.authRoleNames.includes("admin");
    },
    isInstitutionAdmin() {
      return this.authRoleNames.includes("admin institution")
        || this.authRoleNames.includes("institution_admin")
        || this.authRoleNames.includes("institution admin");
    },
    canAssignInstructors() {
      return this.isPlatformAdmin || this.isInstitutionAdmin;
    },
    currentGroupOrganizationId() {
      return (this.currentGroupCard && this.currentGroupCard.organization_id) || this.form.organization_id || null;
    },
    isInstructorPickerDisabled() {
      return this.isPlatformAdmin && !this.currentGroupOrganizationId;
    },
    instructorPickerPlaceholder() {
      if (this.isInstructorPickerDisabled) {
        return this.localization("Select an institution first");
      }
      return this.localization("Select instructors");
    },
    isStudent() {
      const user = this.auth();
      const type = user && user.type ? String(user.type).toLowerCase() : '';
      const roles = this.$store.getters["roles/authUserRoles"] || [];
      const hasStudentRole = roles.some(r => r && String(r).toLowerCase() === 'user');
      return type === 'user' || hasStudentRole;
    },
  },
  methods: {
    fetchMembers(query) {
       this.$store.dispatch("data_cards/GetGroupMembers", {id: this.$route.params.id, query: query});
    },
    fetchSubTopicsCards(query) {
      this.$store.dispatch("data_cards/GetSubTopicsCards", {id: this.$route.params.id, query: query});
    },
    instructorLabel(user) {
      const name = `${user.first_name || ""} ${user.last_name || ""}`.trim();
      if (name && user.email) {
        return `${name} (${user.email})`;
      }
      return name || user.email || String(user.id);
    },
    fetchInstitutionInstructors() {
      if (!this.canAssignInstructors) {
        return;
      }
      const organizationId = this.currentGroupOrganizationId;
      if (this.isPlatformAdmin && !organizationId) {
        this.$store.commit("data_cards/SET_INSTITUTION_INSTRUCTORS", []);
        return;
      }
      const query = {};
      if (this.isPlatformAdmin && organizationId) {
        query.organization_id = organizationId;
      }
      const groupHasOrg = this.currentGroupCard && this.currentGroupCard.organization_id;
      this.$store.dispatch("data_cards/GetInstitutionInstructors", {
        query,
        groupCardId: groupHasOrg ? this.$route.params.id : null
      }).catch((error) => {
        this.assignError = extractApiError(error);
      });
    },
    handleOrganizationChange() {
      this.assignError = "";
      this.form.institution_users = [];
      this.fetchInstitutionInstructors();
    },
    showAddMemberModal() {
      if (!this.canAssignInstructors) {
        return;
      }
      this.assignError = "";
      this.showModal = true;
      if (this.isPlatformAdmin && !this.currentGroupOrganizationId) {
        this.$store.dispatch("organization/orgs");
      }
      this.fetchInstitutionInstructors();
    },
    closeModal() {
      this.showModal = false;
      this.form.institution_users = [];
      this.form.organization_id = null;
      this.assignError = "";
    },
    submitAddMembers() {
      const uniqueUsers = [...this.form.institution_users];
      const payload = {
        id: this.$route.params.id,
        userIds: uniqueUsers
      };
      if (this.isPlatformAdmin && this.currentGroupOrganizationId) {
        payload.organization_id = this.currentGroupOrganizationId;
      }

      this.$store.dispatch("data_cards/AddGroupMembers", payload).then(() => {
        this.closeModal();
        this.fetchMembers();
         Swal.fire({
            title: "",
            icon: "success",
            text: `${this.localization("Saved")}`,
            confirmButtonText: `${this.localization("Ok")}`,
            type: "success",
            confirmButtonClass: "btn btn-success",
            buttonsStyling: false,
          });
      }).catch((error) => {
        this.assignError = extractApiError(error);
      });
    },
    removeMember(userId) {
       Swal.fire({
        title: "",
        text: `${this.localization("Are You Sure")}`,
        type: "warning",
        icon: "warning",
        showCancelButton: true,
        confirmButtonClass: "btn btn-success ",
        cancelButtonClass: "btn btn-danger ",
        confirmButtonText: `${this.localization("Delete")}`,
        cancelButtonText: `${this.localization("Cancel")}`,
        buttonsStyling: false
      }).then(result => {
        if (result.isConfirmed) {
            this.$store.dispatch("data_cards/RemoveGroupMember", {
                id: this.$route.params.id,
                userId: userId
            }).then(() => {
                this.fetchMembers();
                 Swal.fire({
                    title: "",
                    icon: "success",
                    text: `${this.localization("Deleted")}`,
                    confirmButtonText: `${this.localization("Ok")}`,
                    type: "success",
                    confirmButtonClass: "btn btn-success",
                    buttonsStyling: false,
                  });
            });
        }
      });
    },
    toggleCompleted(member) {
      const newStatus = member.status === 'completed' ? 'answered' : 'completed';
      const groupId = this.$route.params.id;
      const userId = member.user_id || member.id;
      this.$store.dispatch('data_cards/UpdateMemberStatus', {
        groupId: groupId,
        userId: userId,
        status: newStatus
      }).then((response) => {
        const resolvedStatus = (response && response.status) || newStatus;
        let successMessage = '';
        if (resolvedStatus === 'completed') {
          successMessage = this.localization('Marked as Completed');
        } else if (resolvedStatus === 'answered') {
          successMessage = this.localization('Marked as Answered');
        } else {
          successMessage = this.localization('Reverted to New');
        }

        Swal.fire({
          title: '',
          icon: 'success',
          text: successMessage,
          confirmButtonText: `${this.localization('Ok')}`,
          type: 'success',
          confirmButtonClass: 'btn btn-success',
          buttonsStyling: false,
        });
      }).catch(() => {
        Swal.fire({
          title: '',
          icon: 'error',
          text: `${this.localization('Failed to update status. Please try again.')}`,
          confirmButtonText: `${this.localization('Ok')}`,
          confirmButtonClass: 'btn btn-danger',
          buttonsStyling: false,
        });
      });
    },
    viewMemberAnswers(member) {
      const groupId = this.$route.params.id;
      const userId = member.user_id || member.id;
      this.$router.push(`/data_cards/${groupId}/member/${userId}/answers`);
    },
    handleSelectionChange(val) {
      this.selectedMembers = val;
    },
    printAllSelected() {
      if (this.subTopicsCards.length === 0) {
        Swal.fire({
          icon: 'warning',
          text: this.localization('No subtopics assigned to this group.'),
          confirmButtonText: this.localization('Ok'),
          buttonsStyling: false,
          confirmButtonClass: "btn btn-warning"
        });
        return;
      }

      this.localLoading = true;
      const subtopicIds = this.subTopicsCards.map(s => s.id);
      const allPromises = [];

      this.selectedMembers.forEach(member => {
        const userPromises = subtopicIds.map(subtopicId => {
          return request({
            url: `/sub_topics_card/show/${subtopicId}`,
            method: 'get',
            params: { user_id: member.user_id }
          });
        });

        allPromises.push(
          Promise.all(userPromises).then(responses => {
            const subtopics = responses.map(r => r.subTopicsCard);
            return {
              user: member,
              subtopics: subtopics
            };
          })
        );
      });

      Promise.all(allPromises).then(membersData => {
        this.printingMembers = membersData;

        // Wait for DOM update
        this.$nextTick(() => {
          const originalTitle = document.title;
          document.title = "";

          window.print();

          document.title = originalTitle;
          // Reset printingMembers after print
          this.printingMembers = [];
        });
      }).catch(err => {
        console.error(err);
        Swal.fire({
          icon: 'error',
          text: this.localization('Failed to load answers for printing.'),
          confirmButtonText: this.localization('Ok'),
          buttonsStyling: false,
          confirmButtonClass: "btn btn-danger"
        });
      }).finally(() => {
        this.localLoading = false;
      });
    },
    printMemberAnswers(member) {
      if (this.subTopicsCards.length === 0) {
        Swal.fire({
          icon: 'warning',
          text: this.localization('No subtopics assigned to this group.'),
          confirmButtonText: this.localization('Ok'),
          buttonsStyling: false,
          confirmButtonClass: "btn btn-warning"
        });
        return;
      }

      const subtopicIds = this.subTopicsCards.map(s => s.id);
      this.localLoading = true;

      const promises = subtopicIds.map(id => {
        return request({
          url: `/sub_topics_card/show/${id}`,
          method: 'get',
          params: { user_id: member.user_id }
        });
      });

      Promise.all(promises).then(responses => {
        const subtopics = responses.map(r => r.subTopicsCard);
        this.printingMembers = [{
          user: member,
          subtopics: subtopics
        }];

        // Wait for DOM update
        this.$nextTick(() => {
          const originalTitle = document.title;
          document.title = "";

          window.print();

          document.title = originalTitle;
          // Reset printingMembers after print
          this.printingMembers = [];
        });
      }).catch(err => {
        console.error(err);
        Swal.fire({
          icon: 'error',
          text: this.localization('Failed to load answers for printing.'),
          confirmButtonText: this.localization('Ok'),
          buttonsStyling: false,
          confirmButtonClass: "btn btn-danger"
        });
      }).finally(() => {
        this.localLoading = false;
      });
    },
    clearState() {
      this.$store.commit("data_cards/SET_GROUP_MEMBERS", []);
      this.$store.commit("data_cards/SET_TOTAL_GROUP_MEMBERS", 0);
      this.$store.commit("data_cards/SET_SUB_TOPICS_CARDS", []);
      this.$store.commit("data_cards/SET_TOTAL_SUB_TOPICS_CARDS", 0);
      this.$store.commit("data_cards/SET_GROUP_NAME", null);
      this.$store.commit("data_cards/SET_CURRENT_GROUP_CARD", null);
      this.$store.commit("data_cards/SET_INSTITUTION_INSTRUCTORS", []);
    },
    getScoreLabel(score) {
      if (score == null) return '-';
      const val = parseInt(score);
      if (val >= 25 && val <= 35) {
        return this.localization('Use First');
      } else if (val >= 7 && val <= 17) {
        return this.localization('Avoid');
      } else if (val >= 18 && val <= 24) {
        return this.localization('As Needed');
      }
      return '-';
    },
    getPrintDate() {
      const today = new Date();
      const day = String(today.getDate()).padStart(2, '0');
      const month = String(today.getMonth() + 1).padStart(2, '0');
      const year = today.getFullYear();
      return `${month}/${day}/${year}`;
    }
  },
  created() {
    this.clearState();
  },
  mounted() {
    const isNewGroup = !!this.$route.query.newGroup;
    this.$store.dispatch("data_cards/ShowGroupCard", this.$route.params.id).then(() => {
      if (isNewGroup) {
        this.showAddMemberModal();
      }
    });
    if (isNewGroup) {
      this.$router.replace({ name: this.$route.name, params: this.$route.params });
    }
  }
};
</script>

<style lang="scss" scoped>
.main_profile_wrapper {
  background: #fff;
  width: 100%;
  max-width: 100%;
  padding: 30px;
}
.main_table {
  margin-top: 30px;
  border-radius: 8px;
  border: 1px solid #eaecf0;
}
.patterns_wrapper {
  .wrapper_for_pattern {
    display: flex;
    justify-content: space-between;
    gap: 1.5%;
    flex-wrap: wrap; /* Wrap cards into 2 rows of 2 cards */
    margin-left: 20px;
    margin-right: 20px;
  }
  .main_pattern_card {
    border-radius: 8px;
    width: calc(97% / 2); /* 2 cards per row */
    margin-bottom: 20px; /* Spacing between rows */
    border: 1px solid transparent;
    .part_one {
      padding: 25px 30px; /* Increased padding for height and space */
      border-top-left-radius: 8px;
      border-top-right-radius: 8px;
      border: 1px solid transparent;
      &.round_card {
        border-radius: 8px;
        border: 1px solid #eaecf0;
      }
      .pattern_name {
        font-weight: 600;
        font-size: 24px; /* Larger font size */
        color: #fff;
        margin-bottom: 25px;
        display: block;
      }
      .numbers_wrapper {
        display: flex;
        justify-content: space-between;
        align-items: center;
        .number {
          font-weight: 600;
          font-size: 64px; /* Larger numbers */
          color: #fff;
        }
        .number_key {
          font-weight: 600;
          font-size: 22px; /* Larger range label */
          color: #fff;
        }
      }
    }
  }
}
@media (max-width: 991px) {
  .patterns_wrapper .main_pattern_card .part_one {
    padding: 20px 24px;
    .pattern_name {
      font-size: 20px;
      margin-bottom: 15px;
    }
    .numbers_wrapper {
      .number {
        font-size: 48px !important;
      }
      .number_key {
        font-size: 18px !important;
      }
    }
  }
}
@media (max-width: 768px) {
  .patterns_wrapper .main_pattern_card .part_one {
    padding: 15px 20px;
    .pattern_name {
      font-size: 16px;
      margin-bottom: 10px;
    }
    .numbers_wrapper {
      .number {
        font-size: 36px !important;
      }
      .number_key {
        font-size: 14px !important;
      }
    }
  }
}
</style>

<style lang="scss" scoped>
@media print {

  /* Hide main app wrapper and other non-printable contents */
  .sidebar,
  .navbar,
  .footer,
  footer,
  nav,
  [class*="footer"],
  [id*="footer"],
  [class*="sidebar"],
  [id*="sidebar"],
  .main_table,
  .bg-light.border-bottom,
  .main_profile_wrapper > *:not(.the_main_container_for_print_all_pdf) {
    display: none !important;
  }

  /* Reset layout constraints for print */
  html,
  body,
  #app,
  .wrapper,
  .main-panel,
  .content,
  .main_profile_wrapper {
    position: static !important;
    width: 100% !important;
    height: auto !important;
    margin: 0 !important;
    padding: 0 !important;
    overflow: visible !important;
    background: #fff !important;
    box-shadow: none !important;
  }

  body {
    background-color: #fff !important;
  }

  /* Ensure backgrounds render in print */
  * {
    -webkit-print-color-adjust: exact !important;
    color-adjust: exact !important;
  }

  @page {
    size: auto;
    margin: 8mm 10mm 12mm 10mm !important;
  }

  .the_main_container_for_print_all_pdf {
    display: block !important;
    width: 100% !important;
    max-width: 100% !important;
    padding: 0 !important;
    margin: 0 !important;
    background: #fff !important;
  }

  .main_container {
    width: 100% !important;
    max-width: 100% !important;
    padding: 1mm 1mm !important;
    margin: 0 !important;
    box-sizing: border-box !important;
  }

  .main_auth_user_info {
    margin-bottom: 6px !important;
    padding-bottom: 6px !important;
  }

  .subtopic-print-header {
    margin-bottom: 4px !important;
  }

  .component-print-block {
    width: 100% !important;
    max-width: 100% !important;
    padding: 6px !important;
    margin-bottom: 6px !important;
    box-sizing: border-box !important;
  }

  /* Outer per-member wrapper — starts each user on a new page (except the first) */
  .print-member-block {
    display: block !important;
    width: 100% !important;
    box-sizing: border-box !important;
  }

  .print-member-block + .print-member-block {
    page-break-before: always !important;
    break-before: page !important;
  }

  .print-page-break {
    page-break-after: always !important;
    break-after: page !important;
    padding: 5mm !important;
    box-sizing: border-box !important;
  }

  /* Prevent blank trailing page after the last block */
  .print-page-break:last-child {
    page-break-after: avoid !important;
    break-after: avoid !important;
  }

  .print-page-break.mb-5 {
    margin-bottom: 0 !important;
  }

  .page-break-inside-avoid {
    page-break-inside: avoid !important;
    break-inside: avoid !important;
  }

  .patterns_wrapper {
    .wrapper_for_pattern {
      display: flex !important;
      flex-direction: row !important;
      flex-wrap: nowrap !important;
      justify-content: space-between !important;
      gap: 1% !important;
      width: 100% !important;
      margin-left: 0 !important;
      margin-right: 0 !important;
    }
    .main_pattern_card {
      width: calc(96% / 4) !important;
      margin-bottom: 0 !important;
      display: block !important;
      
      .part_one {
        padding: 10px !important;
        .pattern_name {
          font-size: 13px !important;
          margin-bottom: 8px !important;
        }
        .numbers_wrapper {
          .number {
            font-size: 28px !important;
          }
          .number_key {
            font-size: 12px !important;
          }
        }
      }
    }
  }
}
</style>

<!-- Unscoped styles to reach inside v-html content -->
<style lang="scss">
@media print {
  /* Override any inline width/style on tables rendered via v-html */
  .component-body table,
  .component-body table[style],
  .component-body > table {
    width: 100% !important;
    max-width: 100% !important;
    min-width: 0 !important;
    table-layout: fixed !important;
    border-collapse: collapse !important;
    box-sizing: border-box !important;
    /* Prevent tables from splitting across pages */
    // page-break-inside: avoid !important;
    // break-inside: avoid !important;
  }

  /* Also prevent rows from splitting across pages */
  .component-body table tr {
    page-break-inside: avoid !important;
    break-inside: avoid !important;
  }

  /* Force all td/th to share width evenly and wrap text */
  .component-body table td,
  .component-body table th,
  .component-body table td[style],
  .component-body table th[style] {
    width: auto !important;
    max-width: none !important;
    min-width: 0 !important;
    white-space: normal !important;
    word-break: break-word !important;
    overflow-wrap: break-word !important;
    box-sizing: border-box !important;
  }

  /* Remove any fixed-width wrappers around the table */
  .component-body div[style*="width"],
  .component-body span[style*="width"] {
    width: 100% !important;
    max-width: 100% !important;
    min-width: 0 !important;
    overflow: visible !important;
  }

  /* Images stay within bounds */
  .component-body img {
    max-width: 100% !important;
    height: auto !important;
  }

  /* Ensure the body wrapper itself is full width */
  .component-body {
    width: 100% !important;
    max-width: 100% !important;
    overflow: visible !important;
    box-sizing: border-box !important;
  }
}
</style>
